import axios from 'axios';

/**
 * Password Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Password template.
 *
 * @namespace password
 */

// import $ from 'jquery';

// const selectors = {
//   recoverPasswordForm: '#RecoverPassword',
//   hideRecoverPasswordLink: '#HideRecoverPasswordLink',
// };

// function onShowHidePasswordForm(evt) {
//   evt.preventDefault();
//   toggleRecoverPasswordForm();
// }

// function checkUrlHash() {
//   const hash = window.location.hash;

//   // Allow deep linking to recover password form
//   if (hash === '#recover') {
//     toggleRecoverPasswordForm();
//   }
// }

// /**
//  *  Show/Hide recover password form
//  */
// function toggleRecoverPasswordForm() {
//   $('#RecoverPasswordForm').toggleClass('hide');
//   $('#CustomerLoginForm').toggleClass('hide');
// }

// /**
//  *  Show reset password success message
//  */
// function resetPasswordSuccess() {
//   const $formState = $('.reset-password-success');

//   // check if reset password form was successfully submited.
//   if (!$formState.length) {
//     return;
//   }

//   // show success message
//   $('#ResetSuccess').removeClass('hide');
// }

// if ($(selectors.recoverPasswordForm).length) {
//   checkUrlHash();
//   resetPasswordSuccess();

//   $(selectors.recoverPasswordForm).on('click', onShowHidePasswordForm);
//   $(selectors.hideRecoverPasswordLink).on('click', onShowHidePasswordForm);
// }

document.addEventListener('DOMContentLoaded', function() {
  const passwordRecoveryContainer = document.getElementById('RecoverPasswordForm');
  const customerLoginForm = document.getElementById('CustomerLoginForm');
  const recoverPasswordLink = document.getElementById('RecoverPassword');
  const cancelPasswordRecovery = document.getElementById('HideRecoverPasswordLink');
  const termsAndCondsCheckbox = document.getElementById('TermsAndConditions');
  const submitCustomerRegistration = document.getElementById('SubmitCustomerRegistration');
  const customerRegistrationForm = document.getElementById('create_customer');
  const recoverPasswordForm = passwordRecoveryContainer.querySelector('form');
  const showPasswordBtn = document.querySelector('.show-password');

  const hash = window.location.hash;
  if (hash === '#recover') {
    toggleRecoverPasswordForm();
  }

  function toggleRecoverPasswordForm() {
    if (!passwordRecoveryContainer) {
      return;
    }
    passwordRecoveryContainer.classList.toggle('hide');
    customerLoginForm.classList.toggle('hide');
  }

  function validateCustomerForm() {
    const inputElems = customerRegistrationForm.querySelectorAll('.form-input');
    let formValid = true;
    inputElems.forEach((formElem) => {
      if (formElem.value !== '') {
        return;
      }
      formElem.classList.add('form-input--error');
      formValid = false;
    });
    return formValid;
  }

  function resetForm(formElem) {
    const formInputs = formElem.querySelectorAll('.form-input');
    formInputs.forEach(formInput => {
      formInput.classList.remove('form-input--error');
    });
  }

  // Check if the page has any invalid form elements on it and reset them when it changes.
  function listenForFormChanges() {
    const formInputErrors = document.querySelectorAll('.form-input--error');
    if (formInputErrors.length) {
      formInputErrors.forEach((formInput) => {
        formInput.addEventListener('blur', (evt) => {
          if (evt.target.value !== '') {
            evt.target.classList.remove('form-input--error');
          }
        });
      });
    }
  }

  recoverPasswordLink.addEventListener('click', function(evt) {
    evt.preventDefault();
    toggleRecoverPasswordForm();
  });

  cancelPasswordRecovery.addEventListener('click', function(evt) {
    evt.preventDefault();
    toggleRecoverPasswordForm();
  });

  termsAndCondsCheckbox.addEventListener('change', function(evt) {
    evt.preventDefault();
    submitCustomerRegistration.disabled = !termsAndCondsCheckbox.checked;
  });

  submitCustomerRegistration.addEventListener('click', function(evt) {
    resetForm(customerRegistrationForm);
    if (!validateCustomerForm()) {
      // Show error message saying fields are required
      // At some point...
      listenForFormChanges();
      evt.preventDefault();
    }
  });

  showPasswordBtn.addEventListener('click', function(evt) {
    evt.preventDefault();
    const sibling = evt.target.previousElementSibling.previousElementSibling;
    if (sibling.id === 'CustomerPassword') {
      sibling.type = sibling.type === 'password' ? 'text' : 'password';
    }
  });

  recoverPasswordForm.addEventListener('submit', function(evt) {
    evt.preventDefault();
    const formAction = evt.target.attributes.action.value;
    const formData = new FormData(recoverPasswordForm);
    axios({
      method: 'POST',
      url: formAction,
      data: formData,
    }).then(() => {
      document.getElementById('ResetSuccess').classList.remove('hide');
      toggleRecoverPasswordForm();
    }).catch(error => {
      document.getElementById('ResetError').classList.remove('hide');
      console.error(error);
    });
  });


});
